import React from 'react';
import { NavLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';

import { LuLayoutDashboard, LuActivity } from "react-icons/lu";
import { MdOutlineLeaderboard, MdPostAdd, MdPerson, MdOutlineLocalLibrary } from "react-icons/md";
import { RiLogoutCircleRLine, RiContactsFill } from "react-icons/ri";
import { PiUsersThreeDuotone, PiUsersThreeFill } from "react-icons/pi";
import { IoIosPerson } from "react-icons/io";

const Sidebar = () => {
  // Reusable NavLink with active styling
  const renderLink = (to, icon, text) => (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        display: 'flex',
        alignItems: 'center',
        color: isActive ? '#fff' : '#ccc',
        backgroundColor: isActive ? '#333' : 'transparent',
        textDecoration: 'none',
        fontSize: '0.95rem',
        fontFamily: 'Poppins, sans-serif',
        padding: '12px 15px',
        borderRadius: isActive ? '4px' : '0',
        transition: 'all 0.3s ease',
      })}
      end={to === '/Dashboard'} // Ensures exact match for root routes
    >
      {React.cloneElement(icon, { style: { marginRight: '8px', fontSize: '1.2rem' } })}
      {text}
    </NavLink>
  );

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: 250,
        height: '100vh',
        bgcolor: '#000',
        color: '#fff',
        overflowY: 'auto',
        zIndex: 1200,
        paddingTop: '10px',
        position: 'relative', // Ensure absolute positioning works for logout
      }}
    >
      <Stack direction="row" justifyContent="center" sx={{ padding: '15px 0' }}>
        <Box
          component="h2"
          sx={{
            fontSize: '1.5rem',
            fontFamily: 'Poppins, sans-serif',
            color: '#fff',
            margin: 0,
          }}
        >
          Admin Panel
        </Box>
      </Stack>

      <List sx={{ padding: 0 }}>
        {/* Main Navigation */}
        {[
          { to: '/Dashboard', icon: <LuLayoutDashboard />, label: 'Dashboard' },
          { to: '/AddAbout', icon: <LuActivity />, label: 'Add About' },
          { to: '/Booking', icon: <MdPostAdd />, label: 'Bookings' },
          { to: '/Leads', icon: <MdOutlineLeaderboard />, label: 'Facilities' },
          { to: '/Function', icon: <MdOutlineLeaderboard />, label: 'Events' },
          { to: '/OfcBearer', icon: <MdPerson />, label: 'Office Bearer' },
          { to: '/ExeMember', icon: <PiUsersThreeFill />, label: 'Executive Member' },
          { to: '/ContactAdmin', icon: <RiContactsFill />, label: 'Contact' },
          { to: '/NearBy', icon: <MdOutlineLocalLibrary />, label: 'Near By' },
          { to: '/GuruList', icon: <PiUsersThreeDuotone />, label: "Guru's" },
          { to: '/Users', icon: <IoIosPerson />, label: "User's" },
        ].map((item) => (
          <ListItem key={item.to} disablePadding>
            {renderLink(item.to, item.icon, item.label)}
          </ListItem>
        ))}

        {/* Logout (Sticky at Bottom) */}
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
          }}
        >
          <ListItem disablePadding>
            {renderLink('/AdminLogin', <RiLogoutCircleRLine />, 'Logout')}
          </ListItem>
        </Box>
      </List>
    </Box>
  );
};

export default Sidebar;